import { render, staticRenderFns } from "./ActiveQueueCalls.vue?vue&type=template&id=a058949a"
import script from "./ActiveQueueCalls.vue?vue&type=script&lang=js"
export * from "./ActiveQueueCalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports